export const FETCH_SENDER_REQUEST = 'FETCH_SENDER_REQUEST';
export const FETCH_SENDER_SUCCESS = 'FETCH_SENDER_SUCCESS';
export const FETCH_SENDER_FAILURE = 'FETCH_SENDER_FAILURE';
